import React, { Component } from "react";
import SettingsCard from "../../components/menu/SettingsCard";
import classNames from "classnames";
import { Icons, Avatar } from "cakemail-ui-components/lib/react";
import { getAccountUsage } from "utils/apiUtils";

class Settings extends Component {
	constructor(props) {
		super(props);

		this.state = {
			active: false,
		};

		this.changeStatus = this.changeStatus.bind(this);
	}

	changeStatus() {
		if (!this.state.active) {
			getAccountUsage(true, this.props.account.id);
		}
		this.setState({
			active: !this.state.active,
		});
	}

	render() {
		let settingsCard = null;
		let avatarClasses = classNames("user-avatar", {
			"avatar-small-active": this.state.active,
		});
		let profileArrow = classNames("profile-arrow", {
			"profile-arrow-rotate": this.state.active,
		});

		let name = "";
		let avatar = <Avatar size="small" fullName="" email="" />;

		if (this.state.active === true) {
			settingsCard = (
				<SettingsCard
					{...this.props}
					changeStatus={this.changeStatus}
					settingsRef={this.settingsRef}
				/>
			);
		}

		if (this.props.user) {
			let firstname =
				this.props.user.first_name === "-" || !this.props.user.first_name
					? ""
					: this.props.user.first_name;
			let lastname =
				this.props.user.last_name === "-" || !this.props.user.last_name
					? ""
					: this.props.user.last_name;
			name = firstname + " " + lastname;
			avatar = (
				<Avatar size="small" fullName={name} email={this.props.user.email} />
			);
		}

		return (
			<div id="settings">
				<ul
					id="profile"
					onClick={this.changeStatus}
					ref={(ref) => {
						this.settingsRef = ref;
					}}
				>
					<li className={avatarClasses}>{avatar}</li>
					<li className="user-client">
						<span className="user-name">{name}</span>
						<span className="client-name">{this.props.user.email}</span>
					</li>
					<li className={profileArrow}>
						<Icons name="micro-glyph-arrow-head" type="micro-glyph-grape" />
					</li>
				</ul>
				{settingsCard}
			</div>
		);
	}
}

export default Settings;
